module.exports = __webpack_public_path__ + "static/integrations-with-us-8a337cdfd02f8aa53126ac2a7b604fde.png";